import isObject from 'lodash/isPlainObject'
import formatDate from 'date-fns/format'
import isDate from 'date-fns/is_date'

export default function formatQuery(object = {}) {
  const val = (key, value) => encodeURIComponent(key) + '=' + encodeURIComponent(value)
  return Object.keys(object).reduce((arr, key) => {
    let value = object[key]
    if (value === null || value === undefined) return arr

    if (Array.isArray(value)) {
      value = value.map(oneValue => formatQuery({[key]: oneValue}))
    } else if (isObject(value)) {
      value = Object.keys(value).map(subKey => formatQuery({[`${key}[${subKey}]`]: value[subKey]}))
    } else if (value instanceof Map) {
      value = [...value].map(([subKey, subValue]) => formatQuery({[`${key}[${subKey}]`]: subValue}))
    } else if (isDate(value)) {
      value = val(key, formatDate(value, 'YYYY-MM-DD'))
    } else {
      value = val(key, value)
    }
    return arr.concat(value)
  }, []).filter(Boolean).join('&')
}



// WEBPACK FOOTER //
// ./client/utils/formatQuery.js